import React from "react";
import { useTranslation } from "react-i18next";

export const ProductCard = ({ product, activeProduct, changeActiveProduct, classList }) => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;
    return (
        <button className={"nav-link" + classList} id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true" onClick={() => changeActiveProduct(product)}>
            <div className="icon-image">
                <img src={product?.product_image ? product?.product_image : require("../assets/images/sedan.png")} alt="product_image" />
            </div>
            {currentLanguage === 'ar' ? product.product_name_ar : product.product_name}
        </button>
    );
}
